var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftAtom4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 616,
    viewBox: "0 0 311 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.7 485.977C182.339 486.101 182.825 486.848 182.802 487.761C182.75 488.657 182.01 489.165 181.371 489.041L160.297 486.005C159.401 485.952 158.892 485.213 159.016 484.574C159.069 483.677 159.808 483.169 160.728 483.214L181.7 485.977ZM64.8159 535.239C64.1768 535.115 63.4111 534.447 63.535 533.808C63.5873 532.912 64.2487 532.123 64.8878 532.247L96.6111 532.917C97.2502 533.041 98.016 533.709 97.9703 534.629C97.8463 535.268 97.1783 536.033 96.5392 535.91L64.8159 535.239ZM131.314 543.184C130.597 542.78 130.112 542.033 130.493 541.323C130.819 540.325 131.637 540.097 132.354 540.501L156.121 549.94C156.838 550.345 157.324 551.091 156.943 551.802C156.538 552.519 155.792 553.004 155.081 552.623L131.314 543.184Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7936 570.95C96.3893 571.668 95.5713 571.896 94.854 571.492C94.1366 571.087 93.9084 570.269 94.3128 569.552L104.71 550.303C105.115 549.586 105.933 549.358 106.65 549.762C107.367 550.167 107.596 550.984 107.191 551.702L96.7936 570.95Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.048 519.315C123.644 520.032 122.826 520.26 122.109 519.856C121.391 519.451 121.085 518.353 121.496 517.659L135.691 494.958C136.095 494.241 136.991 494.293 137.709 494.697C138.426 495.102 138.374 495.998 137.97 496.715L124.048 519.315Z",
    fill: "#263238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4202,
    cy: 532.582,
    r: 23.9482,
    transform: "rotate(164.41 40.4202 532.582)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.884,
    cy: 556.701,
    r: 14.0367,
    transform: "rotate(164.41 167.884 556.701)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.377,
    cy: 483.405,
    r: 14.0367,
    transform: "rotate(164.41 145.377 483.405)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.151,
    cy: 534.991,
    r: 18.9925,
    transform: "rotate(164.41 114.151 534.991)",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.0592,
    cy: 577.729,
    r: 9.41142,
    transform: "rotate(164.41 90.0592 577.729)",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.672,
    cy: 489.63,
    r: 10.4026,
    transform: "rotate(164.41 190.672 489.63)",
    fill: "#80FFAF",
    stroke: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftAtom4);
export default __webpack_public_path__ + "static/media/gift-atom-4.7b7848302c691c8399d285829a58a959.svg";
export { ForwardRef as ReactComponent };